export type Testimonial = {
    id: string;
    first_name: string;
    last_name: string;
    company: string;
    position: string;
    content: string;
    shape_type: number;
}

export const TESTIMONIALS_MOCK: Testimonial[] = [
    {
      id: "1",
      first_name: "Nexlabs",
      last_name: "Team",
      company: "On-Chain Index Platform",
      position: "DeFi & RWA",
      content: "They turned a complex index engine into an interface anyone can use. Crypto, RWAs and commodities now sit in one product that simply works.",
      shape_type: 1
    },
    {
      id: "2",
      first_name: "Sitelab",
      last_name: "Team",
      company: "AI Website Builder",
      position: "AI & SaaS",
      content: "Development, hosting and support in a single platform — they built the whole stack and kept it fast and simple to maintain.",
      shape_type: 2
    },
    {
      id: "3",
      first_name: "Colichain",
      last_name: "Team",
      company: "L2 for Real-World Assets",
      position: "L1/L2 & RWA",
      content: "From the L2 infrastructure to the marketplace on top of it, they delivered a stack that scales with us instead of holding us back.",
      shape_type: 3
    },
    {
      id: "4",
      first_name: "Quantum Compliance",
      last_name: "Team",
      company: "PQC Readiness Platform",
      position: "Quantum Security",
      content: "They made post-quantum risk understandable for enterprise buyers. The assessment flow explains itself without a single sales call.",
      shape_type: 4
    },
    {
      id: "5",
      first_name: "Spyral",
      last_name: "Team",
      company: "Music Rights & Royalties",
      position: "Blockchain & AI",
      content: "Tokenizing tracks straight from the DAW sounded impossible. They shipped it, and royalty tracking has been transparent ever since.",
      shape_type: 5
    },
    {
      id: "6",
      first_name: "MorningsideAI",
      last_name: "Team",
      company: "AI Consulting Firm",
      position: "Brand & Web",
      content: "Our site finally matches the standard of work we deliver. Sharp design, fast build, and zero friction through the whole process.",
      shape_type: 6
    },
    {
      id: "7",
      first_name: "Coliseum",
      last_name: "Team",
      company: "Cross-Chain DEX",
      position: "DeFi & NFT",
      content: "Bitcoin, Solana and Ethereum swaps under one roof — they handled the hard parts of cross-chain UX so our users never feel the complexity.",
      shape_type: 1
    },
    {
      id: "8",
      first_name: "UK Government",
      last_name: "Team",
      company: "Quantum Security Dashboard",
      position: "Public Sector",
      content: "A demanding brief delivered with real rigour. The dashboard reads clearly under pressure, which is exactly what we needed.",
      shape_type: 2
    },
    {
      id: "9",
      first_name: "Artstake",
      last_name: "Team",
      company: "Digital Art Marketplace",
      position: "NFT & Web3",
      content: "Mobile-first from day one. Onboarding, portfolio and trading feel like one flow rather than three separate products.",
      shape_type: 3
    },
    {
      id: "10",
      first_name: "Ctrlshift",
      last_name: "Team",
      company: "AI, Quantum & Web3 Summit",
      position: "Events",
      content: "They matched the ambition of the summit itself. Everything was live and stable well before our first announcement.",
      shape_type: 4
    },
    {
      id: "11",
      first_name: "Silicon Plan",
      last_name: "Team",
      company: "AI Business Planning",
      position: "AI & SaaS",
      content: "Business plans, pitches and forecasts in one tool — they structured the product logic as carefully as the interface.",
      shape_type: 5
    },
    {
      id: "12",
      first_name: "URANO",
      last_name: "Team",
      company: "RWA Tokenization Ecosystem",
      position: "DeFi & RWA",
      content: "A full-stack tokenization platform built with the security posture our institutional partners expect. They never cut corners.",
      shape_type: 6
    },
    {
      id: "13",
      first_name: "Trustify",
      last_name: "Team",
      company: "Food Traceability Platform",
      position: "Blockchain & AI",
      content: "Farm to table, every step on-chain. Dynamic NFTs per batch sounded ambitious until they made it work in production.",
      shape_type: 1
    },
    {
      id: "14",
      first_name: "Rumoo",
      last_name: "Team",
      company: "Creator Collaboration App",
      position: "Social",
      content: "They understood our market before we finished explaining it. Brands and micro-influencers connect in a couple of taps.",
      shape_type: 2
    },
    {
      id: "15",
      first_name: "Quantum Custody",
      last_name: "Team",
      company: "Digital Asset Custody",
      position: "Quantum Security",
      content: "They translated advanced cryptography into an interface people trust at first glance. Precise work, start to finish.",
      shape_type: 3
    },
    {
      id: "16",
      first_name: "NapulETH",
      last_name: "Team",
      company: "Web3 Community Event",
      position: "Events",
      content: "The site carried the energy of Naples and held up through our busiest traffic days without a hiccup.",
      shape_type: 4
    },
    {
      id: "17",
      first_name: "Unicover",
      last_name: "Team",
      company: "Insurance & Risk Management",
      position: "Insurance",
      content: "Decades of brokerage expertise, finally presented clearly. Reliable delivery and a deployment process we can actually manage.",
      shape_type: 5
    },
    {
      id: "18",
      first_name: "Fractionnaire",
      last_name: "Team",
      company: "Real Estate RWA Platform",
      position: "RWA & DeFi",
      content: "Fractional ownership, secondary trading and compliance in one workflow. They handled the smart contracts and the UX equally well.",
      shape_type: 6
    },
    {
      id: "19",
      first_name: "NMK Creative Hub",
      last_name: "Team",
      company: "Creative Agency",
      position: "Branding & Web",
      content: "As an agency ourselves, our standards were high. They met them and pushed a few ideas further than we had planned.",
      shape_type: 1
    },
    {
      id: "20",
      first_name: "Modus",
      last_name: "Team",
      company: "Fractionalized Real Estate",
      position: "RWA & Social",
      content: "Community-first investing needed a community-first interface. They got the tone right and kept early investors engaged.",
      shape_type: 2
    },
    {
      id: "21",
      first_name: "Wishinwell",
      last_name: "Team",
      company: "Transparent Giving Platform",
      position: "Social Impact",
      content: "Every donation is traceable, and donors can see it for themselves. That transparency is the whole product, and they nailed it.",
      shape_type: 3
    },
    {
      id: "22",
      first_name: "Giordano Rispo",
      last_name: "Studio",
      company: "Photography Portfolio",
      position: "Creative",
      content: "Minimal, quiet, and completely out of the way. The work is the only thing on screen, exactly as I asked.",
      shape_type: 4
    },
    {
      id: "23",
      first_name: "DrugRepAI",
      last_name: "Team",
      company: "AI Research Platform",
      position: "AI & Health",
      content: "Sensitive subject matter handled with real care. The data is presented responsibly and the interface stays clear throughout.",
      shape_type: 5
    },
    {
      id: "24",
      first_name: "Connections AI",
      last_name: "Team",
      company: "Local Services Platform",
      position: "Social & AI",
      content: "Real-time, geo-localized matching that feels instant. They built the trust layer our users rely on every single day.",
      shape_type: 6
    }
];
